export function formatUsdWholeFromCents(
  cents: number | null | undefined,
): string {
  if (cents == null || !Number.isFinite(cents)) return ""
  return (cents / 100).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  })
}
